import React from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/auth';

const OwnerRoute = () => {
    const { isOwner } = useAuth();
    if (isOwner()) {
        return <Outlet />;
    } else {
        <Navigate to={'/home'} />;
    }
};

export default OwnerRoute;
